var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBringInto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0.5V10.5H40L30 0.5ZM27.5 10.5V0.5H13.75C12.7083 0.552083 11.8229 0.916667 11.0938 1.59375C10.4167 2.32292 10.0521 3.20833 10 4.25V23H23.5938L20.5469 19.9531C19.8177 19.0677 19.8177 18.1823 20.5469 17.2969C21.4323 16.5677 22.3177 16.5677 23.2031 17.2969L29.4531 23.5469C30.1823 24.4323 30.1823 25.3177 29.4531 26.2031L23.2031 32.4531C22.3177 33.1823 21.4323 33.1823 20.5469 32.4531C20.1823 32.0885 20 31.6458 20 31.125C20 30.6042 20.1823 30.1615 20.5469 29.7969L23.5938 26.75H10V36.75C10.0521 37.7917 10.4167 38.6771 11.0938 39.4062C11.8229 40.0833 12.7083 40.4479 13.75 40.5H36.25C37.2917 40.4479 38.1771 40.0833 38.9062 39.4062C39.5833 38.6771 39.9479 37.7917 40 36.75V13H30.0781C29.349 13 28.724 12.7656 28.2031 12.2969C27.7344 11.8281 27.5 11.2292 27.5 10.5ZM1.875 23C0.729167 23.1042 0.104167 23.7292 0 24.875C0.104167 26.0208 0.729167 26.6458 1.875 26.75H10V23H1.875Z",
    fill: "#4C5E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBringInto);
export default __webpack_public_path__ + "static/media/bring-into.4b959cd0.svg";
export { ForwardRef as ReactComponent };